import { render } from "./PlayerColumn.vue?vue&type=template&id=10e20ca2&scoped=true"
import script from "./PlayerColumn.vue?vue&type=script&lang=js"
export * from "./PlayerColumn.vue?vue&type=script&lang=js"

import "./PlayerColumn.vue?vue&type=style&index=0&id=10e20ca2&scoped=true&lang=css"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e20ca2"]])

export default __exports__